import {
    WebPost,
    WebGet,
    HttpDownLoad,
    PostDownLoad,
} from '../lib/api.request'
import {
    resolve
} from 'url';
import {
    rejects
} from 'assert';
import Vue from 'vue'
// import {
//   reqLogin,
//   reqTempLogin
// } from '../security/login'

// var com = {
//   login: function templogin() {
//     new Promise((resolve, reject) => {
//       reqTempLogin()
//         .then()(function(resp) {
//           if (resp.rtncode === 1) {
//             if (resp.rltcode === 1) {
//               resolve(resp);
//             } else {
//               reject(resp.rltdesc)
//             }
//           } else {
//             reject(resp.rtndesc)
//           }
//         }).catch(function(err) {
//           reject(err)
//         })
//     })
//     this.mi = "miao";
//     //return r
//   }
// }



export default class ConstJson {
    
    reqGetPaperWordList(){
        var params = {}
        console.log('reqGetPaperWordList===========>')
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/paperword', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetCourtList(){
        var params = {}
        console.log('reqGetCourtList===========>')
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/court', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    ReqGetLeftTree(args) {
        var params = {}
        if (args && args[0]) {
            params.provice = args[0].value
        }
        if (args && args[1]) {
            params.city = args[1].value
        }
        console.log('ReqGetLeftTree===========>')
        console.log(params)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/defaultlefttree', params)
                .then(function(resp) {
                    //console.log(resp)
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    ReqGetLocation(args) {
        var params = {}
        console.log('ReqGetLocation===========>')
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/postion_v2', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    ReqGetTMLeftTree() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/tmfilelefttree', params)
                .then(function(resp) {
                    //console.log(JSON.stringify(resp))
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetIndustry() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/industry', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetTaxes() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/taxes', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetInOut() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/inout', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //优惠项目
    reqGetReduction() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/reduction_item', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //优惠税种
    reqGetReduction_tax() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/reduction_taxes', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //优惠行业
    reqGetReduction_industry() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/reduction_industry', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //优惠行业(yang hao)
    reqGetOffersIndustry() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/wxgzh/findindustry', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetCountry() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/country', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    reqGetProvinceAndCity() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/division', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetDocById() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/doc', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //search参数封装
    goSearch(args) {
        // console.log('goSearch========>')
        // console.log(args)
        var searchData = {
            searchtimes: "",
            frist: {
                text: '',
                potence: '',
                icode: '',
                tcode: '',
                kcode: '',
                country: '',
                ps: {
                    p: '',
                    c: '',
                },
                id: '',
                dirid: '',
            },
            second: [],
            fliter: {
                isfilter: false,
                tagpc: [],
                tagid: ''
            },
            pager: [{ pageindex: 1, pagesize: 8 }], //数组0-全国,1=省级 2=城市

        }

        //pager处理
        let pagers = []
        if (args.pageindex && args.pagesize) {
            let p = {
                pageindex: args.pageindex,
                pagesize: args.pagesize
            }
            pagers.push(p)
        } else {
            let p1 = {
                pageindex: args.pageindex1,
                pagesize: args.pagesize1
            }
            let p2 = {
                pageindex: args.pageindex2,
                pagesize: args.pagesize2
            }
            let p3 = {
                pageindex: args.pageindex3,
                pagesize: args.pagesize3
            }
            pagers.push(p1)
            pagers.push(p2)
            pagers.push(p3)
        }






        searchData.searchtimes = args.fs ? 1 : 2
        ///第一次检索条件
        searchData.frist.text = args.text === undefined ? '' : args.text
        searchData.frist.potence = args.potence === undefined ? '' : args.potence
        searchData.frist.icode = args.icode === undefined ? '' : args.icode
        searchData.frist.tcode = args.tcode === undefined ? '' : args.tcode
        searchData.frist.kcode = args.kcode === undefined ? '' : args.kcode
        searchData.frist.country = args.country === undefined ? '' : args.country
        //searchData.frist.ps = args.ps === undefined ? {} : args.ps
        searchData.frist.ps.p = args.ps === undefined ? '' : args.ps.p
        searchData.frist.ps.c = args.ps === undefined ? '' : args.ps.c
        searchData.frist.id = args.id === undefined ? '' : args.id
        searchData.frist.dirid = args.dirid === undefined ? '' : args.dirid
        //第二次检索条件
        var s = {}
        s.text2 = args.text2 === undefined ? '' : args.text2
        s.stime = args.stime === undefined ? '' : args.stime
        s.etime = args.etime === undefined ? '' : args.etime
        searchData.second.push(s)
        // searchData.second.text2 = args.text2 === undefined ? '' : args.text2
        // searchData.second.stime = args.stime === undefined ? '' : args.stime
        // searchData.second.etime = args.etime === undefined ? '' : args.etime
        //tag过滤
        searchData.fliter.isfilter = args.isfilter
        searchData.fliter.tagpc = args.tagpc === undefined ? [] : args.tagpc
        searchData.fliter.tagid = args.tagid === undefined ? '' : args.tagid
        //页码
        searchData.pager = pagers
        return searchData
    }
    //goSearch2参数封装,与goSearch的区别是first 多两个时间参数,stime,etime
    //searchtime =1
    //二次检索的text2同步到first的text中
    //tagid = ''
    goSearch2(args) {
        // console.log('goSearch========>')
        // console.log(args)
        var searchData = {
            searchtimes: "",
            frist: {
                text: '',
                potence: '',
                icode: '',
                tcode: '',
                kcode: '',
                country: '',
                ps: {
                    p: '',
                    c: '',
                },
                id: '',
                dirid: '',
                stime: '',
                etime: '',
                court:'',
                courttype:0,
            },
            second: [],
            fliter: {
                isfilter: false,
                tagpc: [],
                tagid: ''
            },
            pager: [{ pageindex: 1, pagesize: 8 }], //数组0-全国,1=省级 2=城市
            scencs:args.scencs,
            extend:{company:args.company?args.company:'',mobile: args.mobile?args.mobile:''}
        }

        //pager处理
        let pagers = []
        if (args.pageindex && args.pagesize) {
            let p = {
                pageindex: args.pageindex,
                pagesize: args.pagesize
            }
            pagers.push(p)
        } else {
            let p1 = {
                pageindex: args.pageindex1,
                pagesize: args.pagesize1
            }
            let p2 = {
                pageindex: args.pageindex2,
                pagesize: args.pagesize2
            }
            let p3 = {
                pageindex: args.pageindex3,
                pagesize: args.pagesize3
            }
            pagers.push(p1)
            pagers.push(p2)
            pagers.push(p3)
        }

        //searchData.searchtimes = args.fs ? 1 : 2
        searchData.searchtimes = 1
        ///第一次检索条件
        // searchData.frist.text = args.text === undefined ? '' : args.text
        searchData.frist.text = args.text2 === undefined ? '' : args.text2
        searchData.frist.potence = args.potence === undefined ? '' : args.potence
        searchData.frist.icode = args.icode === undefined ? '' : args.icode
        searchData.frist.tcode = args.tcode === undefined ? '' : args.tcode
        searchData.frist.kcode = args.kcode === undefined ? '' : args.kcode
        searchData.frist.country = args.country === undefined ? '' : args.country
        //searchData.frist.ps = args.ps === undefined ? {} : args.ps
        searchData.frist.ps.p = args.ps === undefined ? '' : args.ps.p
        searchData.frist.ps.c = args.ps === undefined ? '' : args.ps.c
        searchData.frist.id = args.id === undefined ? '' : args.id
        searchData.frist.dirid = args.dirid === undefined ? '' : args.dirid

        searchData.frist.stime = args.stime === undefined ? '' : args.stime
        searchData.frist.etime = args.etime === undefined ? '' : args.etime
        searchData.frist.court = args.court === undefined ? '' : args.court
        searchData.frist.courttype = args.courttype === undefined ? 0 : args.courttype
        //第二次检索条件
        // var s = {}
        // s.text2 = args.text2 === undefined ? '' : args.text2
        // s.stime = args.stime === undefined ? '' : args.stime
        // s.etime = args.etime === undefined ? '' : args.etime
        // searchData.second.push(s)

        //tag过滤
        searchData.fliter.isfilter = args.isfilter
        searchData.fliter.tagpc = args.tagpc === undefined ? [] : args.tagpc
        searchData.fliter.tagid = ''
        //searchData.fliter.tagid = args.tagid === undefined ? '' : args.tagid
        //页码
        searchData.pager = pagers
        return searchData
    }
    //reqGetLasFiles(size, index, classid, tagid, timezone, text,isFirstSearch)
    reqGetLasFiles(args) {
        var params = {
            pagesize: args.pagesize,
            pageindex: args.pageindex,
            id: args.id !== undefined ? args.id : "",
            tagid: args.tagid !== undefined ? args.tagid : "",
            stime: args.stime !== undefined ? args.stime : "",
            etime: args.etime !== undefined ? args.etime : "",
            text: "",
            text2: args.text2 !== undefined ? args.text2 : "",
            fs: args.fs,
            isfilter: args.isfilter,
            tagpc: args.tagpc,
        }

        let rebuildParameters = this.goSearch(params)
        console.log(rebuildParameters)
        let nodes = Vue.prototype.$baseConfig.code
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/new', rebuildParameters, nodes)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //请求地方版默认数据
    //修改为一层查询条件，gosearch2接口
    //scencs=''->政策,scencs='answer'->解答
    reqGetLocalLastFiles(args) {
        var ProviceAndCity = {
            p: args.region.province !== undefined ? args.region.province.value : "",
            c: args.region.city !== undefined ? args.region.city.value : "",
            t: "",
        }

        var params = {
            id: args.classid !== undefined ? args.classid : "",
            tagid: args.tagid !== undefined ? args.tagid : "",
            //city: args.region.city !== undefined ? args.region.city.value : "",
            //provice: args.region.province !== undefined ? args.region.province.value : "",
            ps: ProviceAndCity,
            stime: args.ns.timeZone && args.ns.timeZone.length !== 0 ? args.ns.timeZone[0] : "",
            etime: args.ns.timeZone && args.ns.timeZone.length !== 0 ? args.ns.timeZone[1] : "",
            text2: args.ns.text2 !== undefined ? args.ns.text2 : "",
            potence: args.ns.fileforce.id,
            pagesize1: 10,
            pageindex1: args.p2.index,
            // text2_2: args.p1.text,
            // text2_3: args.p2.text,
            // stime_2: args.p1.timeZone && args.p1.timeZone.length !== 0 ? args.p1.timeZone[0] : "",
            // etime_2: args.p1.timeZone && args.p1.timeZone.length !== 0 ? args.p1.timeZone[1] : "",
            // stime_3: args.p2.timeZone && args.p2.timeZone.length !== 0 ? args.p2.timeZone[0] : "",
            // etime_3: args.p2.timeZone && args.p2.timeZone.length !== 0 ? args.p2.timeZone[1] : "",
            pagesize2: 10,
            pageindex2: args.p1.index,
            pagesize3: 10,
            pageindex3: args.p.index,
            isfilter: args.isfilter,
            fs: args.fs,
            tagpc: args.tagpc,
            scencs:args.scencs,
        }
        let rebuildParameters = this.goSearch2(params)
        console.log(rebuildParameters)
        // console.log(JSON.stringify(rebuildParameters))
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/localnew', rebuildParameters)
                .then(function(resp) {
                    //console.log(resp)
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })

    }

    //请求地方版省级数据
    reqGetLocalProvinceFiles(args) {
        var params = {
            pagesize: args.size,
            pageindex: args.index,
            id: args.classid !== undefined ? args.classid : "",
            tagid: args.tagid !== undefined ? args.tagid : "",
            stime: args.timezone !== undefined ? args.timezone[0] : "",
            etime: args.timezone !== undefined ? args.timezone[1] : "",
            text: args.text !== undefined ? args.text : "",
            city: args.region !== undefined ? args.region.province.value : "",
        }
        console.log(params)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/new', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })

    }



    reqDisplayFile(docid) {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/search/show/' + docid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //客户端数据
    upLoadInfo(src, uid, uguid, postion) {
        var bodyJson = {
            src: src,
            userid: uid === undefined ? '' : uid,
            userguid: uguid === undefined ? '' : uguid,
            ippostion: postion,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/base/postion', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    reqDisplayFile2(row) {
        var bodyJson = {
            strdocid: row.strdocid,
            docid: row.docid,
            h1hit: row.h1hit !== undefined ? row.h1hit : [],
            chit: row.chit !== undefined ? row.chit : [],
            cutwords: row.cutwords !== undefined ? row.cutwords : [],
            chitseq: row.chitseq !== undefined ? row.chitseq : [],
        }
        console.log('reqDisplayFile2:')
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/showdoc', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    reqDownLoadOneFile(strdocid, f, msg) {
        var params = {}
        var url = "/api/public/search/downloadonefile/" + strdocid
        console.log('普通下载文件：' + strdocid)
        HttpDownLoad(url, "", "get", f, msg)
    }

    reqDownLoadFile(strdocid, f, msg) {
        var params = {}
        var url = "/api/public/search/download/" + strdocid
        console.log('云擎下载文件：' + strdocid)
        HttpDownLoad(url, "", "get", f, msg)
    }


    // reqDownLoadFile(docid, f, msg) {
    //     var params = {}
    //     var url = "/api/public/search/download/" + docid
    //     HttpDownLoad(url, "", "get", f, msg)
    // }

    //行业检索,专属
    reqGetIndustryFiles(size, index, args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname //args.otext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid

        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.special
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/industry', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //行业检索,通用
    reqGetIndustryCommonFiles(size, index, args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.common
        parameters.fs = args.fs
        parameters.isfilter = args.ft

        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            //WebPost('/api/public/search/engine/industrycommon/' + size + ',' + index + '', parameters)
            WebPost('/api/public/search/engine/industrycommon', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //综合检索-优惠政策匹配
    reqGetGeneralFilesMatch(size, index, args, isnew = false) {
        var parameters = {}
        parameters.text = args.text
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.text2 = args.text2
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.general
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        parameters.id = args.id
        parameters.scencs=args.scencs
        parameters.court=args.court
        parameters.courttype=args.courttype
        parameters.company=args.company
        parameters.mobile=args.mobile
        let rebuildParameters;
        if (isnew) {
            console.log('goSearch2===>')
            rebuildParameters = this.goSearch2(parameters)
        } else {
            console.log('goSearch===>')
            rebuildParameters = this.goSearch(parameters)
        }
        //let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/matchfile', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //综合检索
    reqGetGeneralFiles(size, index, args, isnew = false) {
        var parameters = {}
        parameters.text = args.text
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.text2 = args.text2
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.general
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        parameters.id = args.id
        parameters.scencs=args.scencs
        parameters.court=args.court
        parameters.courttype=args.courttype
        let rebuildParameters;
        if (isnew) {
            console.log('goSearch2===>')
            rebuildParameters = this.goSearch2(parameters)
        } else {
            console.log('goSearch===>')
            rebuildParameters = this.goSearch(parameters)
        }
        //let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/general', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetTreatyFiles(size, index, args) {
        var parameters = {}
        parameters.country = args.country
        parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.special
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/treaty', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    reqGetCommonTreatyFiles(size, index, args) {
        var parameters = {}
        parameters.country = args.country
        parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.common
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/treatycommon', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    reqGetInOutFiles(size, index, args) {
        var parameters = {}
        parameters.fname = args.fname
        parameters.fcode = args.fcode
        parameters.kcode = args.kcode
        parameters.text = args.ktext
        parameters.text2 = args.text2 === undefined ? "" : args.text2
        parameters.stime = args.stime === undefined ? "" : args.stime
        parameters.etime = args.etime === undefined ? "" : args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid === undefined ? "" : args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.general
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/inout', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //////single
    //税收优惠项目
    reqGetTaxBreakFiles_item(size, index, args) {
        var parameters = {}
        // parameters.fname = args.fname
        // parameters.fcode = args.fcode
        parameters.kcode = args.kcode
        // parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.general
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/reduction_item', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //////single
    //税收优惠税种
    reqGetTaxBreakFiles_taxes(size, index, args) {
        var parameters = {}
        // parameters.fname = args.fname
        // parameters.fcode = args.fcode
        parameters.kcode = args.kcode
        // parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.general
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/reduction_taxes', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //税收优惠double
    //税收优惠行业通用
    reqGetTaxBreakIndustryCommonFiles(size, index, args) {
        var parameters = {}
        // parameters.fname = args.fname
        // parameters.fcode = args.fcode
        parameters.kcode = args.kcode
        // parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.common
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/reduction_industrycommon', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //税收优惠double
    //税收优惠行业专属
    reqGetTaxBreakIndustryFiles(size, index, args) {
        var parameters = {}
        // parameters.fname = args.fname
        // parameters.fcode = args.fcode
        parameters.kcode = args.kcode
        // parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.pageindex = index
        parameters.pagesize = size
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc.special
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/engine/reduction_industry', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }


    //获取云端文件
    //增加id
    reqGetUploadFiles(size, index, args, folderid) {
        var parameters = {}
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = folderid
        parameters.pagesize = size
        parameters.pageindex = index
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft

        parameters.id = args.id

        let rebuildParameters = this.goSearch2(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/searchallfile', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    console.log("err")
                    reject(err)
                })
        })
    }
    //上传文件至云端,选择性上传[1,2]
    upLoadFileToCloud(idlist, folderid) {
        var bodyJson = {
            //docids: fileinfo.docid,
            dirid: folderid,
            docids: idlist,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/add', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //地方版一键上传
    //修改为gosearch2
    reqOneKeyLocalUpload_V2(args) {
        //classid,tagid,timezone,text
        var parameters = {}
        parameters = {
            // pagesize: size,
            // pageindex: index,
            id: args.classid !== undefined ? args.classid : "",
            tagid: args.tagid !== undefined ? args.tagid : "",
            stime: args.ntime !== undefined ? args.ntime[0] : "",
            etime: args.ntime !== undefined ? args.ntime[1] : "",
            text2: args.ntext !== undefined ? args.ntext : "",
            potence: args.potence !== undefined ? args.potence : "",
            ps: args.ps,
            tagpc: args.tagpc,
            dirid: args.folderid !== undefined ? args.folderid : "",
            fs: args.fs,
            isfilter: args.ft
        }
        let rebuildParameters = this.goSearch2(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/new', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }



    //地方版一键上传-城市
    reqOneKeyCityFiles(args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/upload/onekey/industrycommon', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //地方版一键上传-省级
    reqOneKeyProvinceFiles(args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/upload/onekey/industrycommon', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //地方版一键上传-全国
    reqOneKeyCountryFiles(args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/upload/onekey/industrycommon', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //一键上传-最新文件
    reqOneKeyLastFiles(args) {
        //classid,tagid,timezone,text
        var parameters = {}
        parameters = {
            // pagesize: size,
            // pageindex: index,
            id: args.classid !== undefined ? args.classid : "",
            tagid: args.tagid !== undefined ? args.tagid : "",
            stime: args.timeZone !== undefined ? args.timeZone[0] : "",
            etime: args.timeZone !== undefined ? args.timeZone[1] : "",
            text: args.text !== undefined ? args.text : "",
            dirid: args.folderid !== undefined ? args.folderid : "",
        }
        console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/upload/onekey/new', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //一键上传-最新文件V2
    reqOneKeyLastFiles_V2(args) {
        //classid,tagid,timezone,text
        var parameters = {}
        parameters = {
            // pagesize: size,
            // pageindex: index,
            id: args.classid !== undefined ? args.classid : "",
            tagid: args.tagid !== undefined ? args.tagid : "",
            stime: args.timeZone !== undefined ? args.timeZone[0] : "",
            etime: args.timeZone !== undefined ? args.timeZone[1] : "",
            text2: args.text2 !== undefined ? args.text2 : "",
            dirid: args.folderid !== undefined ? args.folderid : "",
            fs: args.fs,
            isfilter: args.ft,
            tagpc: args.tagpc
        }
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/new', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //根据id获取一键上传进度V2
    reqGetOneKey_UploadProgress_V2(identity) {
        var parameters = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/upload/onekey_speed_v2/' + identity)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }



    //原接口地址/api/public/cloud/upload/onekey/general
    //v2接口地址/api/public/cloud/upload/onekey_v2/general
    //一键上传-综合搜索-----------------------------------
    reqOneKeyGeneralFiles_V2(args, isnew = false) {
        var parameters = {}
        parameters.text = args.text
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.text2 = args.text2
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        parameters.id = args.id
        // let rebuildParameters = this.goSearch(parameters)
        let rebuildParameters;
        if (isnew) {
            console.log('goSearch2===>')
            rebuildParameters = this.goSearch2(parameters)
        } else {
            console.log('goSearch===>')
            rebuildParameters = this.goSearch(parameters)
        }
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/general', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //一键上传-行业-通用----------------------------------
    reqOneKeyIndustryCommonFiles_V2(args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/industrycommon', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //一键上传-行业-专属----------------------------------
    reqOneKeyIndustrySpecialFiles_V2(args) {
        var parameters = {}
        parameters.fname = ""
        parameters.fcode = args.fcode
        parameters.text = args.fname
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.icode = args.icode
        parameters.tcode = args.tcode
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/industry', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //一键上传-条约-通用----------------------------------
    reqOneKeyTreatyCommonFiles_V2(args) {
        var parameters = {}
        parameters.country = args.country
        parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/treatycommon', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //一键上传-条约-专属----------------------------------
    reqOneKeyTreatySpecialFiles_V2(args) {
        var parameters = {}
        parameters.country = args.country
        parameters.text = args.ktext
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/treaty', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //一键上传-税收优惠项目-----------------------------------
    reqOneKeyTaxBreakFiles_item_V2(args) {
        var parameters = {}
        parameters.kcode = args.kcode
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/reduction_item', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //一键上传-税收优惠税种-----------------------------------
    reqOneKeyTaxBreakFiles_taxes_V2(args) {
        var parameters = {}
        parameters.kcode = args.kcode
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/reduction_taxes', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }



    //一键上传-税收优惠行业通用-----------------------------------
    reqOneKeyTaxBreakFiles_common_V2(args) {
        var parameters = {}
        parameters.kcode = args.kcode
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/reduction_industrycommon', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //一键上传-税收优惠行业专属-----------------------------------
    reqOneKeyTaxBreakFiles_special_V2(args) {
        var parameters = {}
        parameters.kcode = args.kcode
        parameters.text2 = args.text2
        parameters.stime = args.stime
        parameters.etime = args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/reduction_industry', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }



    //一键上传-进出口-------------------------------------
    reqOneKeyInoutFiles_V2(args) {
        var parameters = {}
        parameters.fname = args.fname
        parameters.fcode = args.fcode
        parameters.kcode = args.kcode
        parameters.text = args.ktext
        parameters.text2 = args.text2 === undefined ? "" : args.text2
        parameters.stime = args.stime === undefined ? "" : args.stime
        parameters.etime = args.etime === undefined ? "" : args.etime
        parameters.potence = args.potence
        parameters.tagid = args.tagid === undefined ? "" : args.tagid
        parameters.dirid = args.dirid
        parameters.ps = args.ps
        parameters.tagpc = args.tagpc
        parameters.fs = args.fs
        parameters.isfilter = args.ft
        let rebuildParameters = this.goSearch(parameters)
        console.log(rebuildParameters)

        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/onekey_v2/inout', rebuildParameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //意见和建议
    reqCreateFeedBack(args) {
        var bodyJson = {
            suggestions: args.suggestions
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/suggestions/suggestions/add', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //文件夹创建默认目录
    reqCreateDefault(args) {
        var bodyJson = {

        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/uploaddir/createdefault', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //获取文件夹固定目录
    reqGetFixedFolder(args) {
        var parameters = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/uploaddir/getfixed', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取文件库根目录
    reqGetRoot(args) {
        var parameters = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/uploaddir/getroot', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取文件库目录树,按父级目录id
    reqGetTreeByParentId(args) {
        var parameters = {}
        parameters.sdirid = args.sdirid
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/uploaddir/gettree', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取文件库目录列表,按父级目录id
    reqGetChildByParentId(args) {
        var parameters = {}
        parameters.sdirid = args.sdirid
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/uploaddir/getchild', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //******************云端文件夹新增，删除，重命名，移动***********////////////////////////////////////
    //获取云端上传文件夹树
    reqGetFolderTree(args) {
        var parameters = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/uploaddir/gettree1', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //云端创建文件夹
    reqFolderCreate(args) {
        var bodyJson = {
            parent_dir_id: args.parent_dir_id,
            dir_name: args.dir_name,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/uploaddir/create', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //云端文件夹改名
    reqFolderRename(args) {
        var bodyJson = {
            dir_id: args.dir_id,
            new_dir_name: args.new_dir_name
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/uploaddir/rename', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //删除云端文件夹及子文件夹，以及文件夹下面的上传文件
    reqFolderDelete(args) {
        var bodyJson = {
            dir_id: args.dir_id,
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/uploaddir/remove', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //移动文件夹(子文件夹跟随移动)
    reqFolderMove(args) {
        var bodyJson = {
            dir_id: args.dir_id,
            new_parent_dir_id: args.new_parent_dir_id
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/uploaddir/move', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }



    ///////************************************////////////////////////////////////////

    //删除云端文件夹文件,按文件id
    reqRemoveFilesByList(folderid, list) {
        var bodyJson = {
            dirid: folderid,
            docids: list
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/remove', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //删除云端指定文件夹下的文件
    reqRemoveFilesByFolderId(folderid) {
        var bodyJson = {
            dirid: folderid,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/clean', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //删除云端指定文件夹下的全文废止(失效)文件
    reqRemoveAbolitionFilesByFolderId(folderid) {
        var bodyJson = {
            dirid: folderid,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/upload/removeabolition', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }



    //工作薄保存
    workBookSave(book) {
        var bodyJson = {
            bookid: book.bookid,
            bookguid: book.bookguid,
            title: book.title,
            industrycode: book.industrycode,
            taxcode: book.taxcode,
            customlabel: book.customlabel,
            keyword: book.keyword,
            contenttext: book.contenttext,
            historyappendix: book.historyappendix,
            newappendix: book.newappendix,
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/workbook/save', bodyJson)
                .then(function(resp) {
                    //resp.newbookid
                    //resp.bookguid
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //工作薄提交
    workBookCommit(book) {
        var bodyJson = {
            bookid: book.bookid,
            bookguid: book.bookguid,
            title: book.title,
            industrycode: book.industrycode,
            taxcode: book.taxcode,
            customlabel: book.customlabel,
            keyword: book.keyword,
            contenttext: book.contenttext,
            historyappendix: book.historyappendix,
            newappendix: book.newappendix,
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/workbook/commit', bodyJson)
                .then(function(resp) {
                    //resp.newbookid
                    //resp.bookguid
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //删除工作薄
    //items.bookid=0 && items.bookguid 则删除所有=bookguid的版本，一个book多个版本只存在一个bookguid
    //items.bookid=0 && items.bookguid 删除指定的一个book版本。
    workBookDelete(books) {
        //{items.bookid,items.bookguid}
        console.log(books)
        var bodyJson = {
            items: books
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/workbook/delete', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //查询工作薄列表
    reqGetWorkBookFiles(size, index, args) {
        var parameters = {}
        //console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/workbook/search/' + size + ',' + index + '', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //根据id获取某个工作薄的相关信息
    getWorkBookItemsById(bookid) {
        //console.log(bookid)
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/workbook/getitem/' + bookid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //下载工作薄文件, 根据docid列表请求下载
    workBookDownLoad(book) {
        //book.docid=[]
        var bodyJson = {
            bookid: book.bookid,
            docid: book.docid,
        }
        return new Promise((resolve, reject) => {
            WebPost('/api/public/cloud/workbook/download/' + bodyJson.bookid + '', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取工作薄下载列表
    getWorkBookDownLoadList(bookid) {
        //console.log(bookid)
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/cloud/workbook/getappendix/' + bookid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //工作薄下载按钮下载
    reqPostDownLoadFile(book, msg) {
        var bodyJson = {
            bookid: book.bookid,
            docid: book.docid,
        }
        var url = "/api/public/cloud/workbook/download/" + bodyJson.bookid

        HttpDownLoad(url, bodyJson, "post", undefined, msg)
    }


    //秘书-云端变动提醒-上传文件库
    reqUploadFilesChanges(size, index, args) {
        var parameters = {}
        //console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/uploadchangelog/search/' + size + ',' + index + '', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //秘书-云端变动提醒-标记单个已读
    reqSetFileChangesIsRead(args) {
        var bodyJson = {
            strdocids: args.strdocids, //数组
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/secretary/uploadchangelog/updatereadflag', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //秘书-云端变动提醒-标记所有已读
    reqSetAllFileChangesIsRead() {
        var bodyJson = {}
        return new Promise((resolve, reject) => {
            WebPost('/api/public/secretary/uploadchangelog/updateallreadflag', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //秘书-云端变动提醒-工作薄变更记录
    reqWorkBookFileChanges(size, index, args) {
        var parameters = {}
        //console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/workbookappendixchangelog/search/' + size + ',' + index + '', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //文件访问记录
    reqFileAccessLogs(size, index, args) {

        //parameters 自动加?和参数的&
        var parameters
        //console.log("args：" + args)
        if (args !== undefined && args.length > 0) {
            parameters = {
                stime: args[0],
                etime: args[1]
            }
        }
        //console.log(parameters)

        //var paramsStr="?"+args[0]+""
        //console.log(parameters)
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/accesslog/search/' + size + ',' + index + '', parameters)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    /////////////////////////商城&&支付////////////////////////////////////////////////////////////////////
    //查询用户是否有代理商编码
    getUserAgentInfo() {
        let obj = {
            // pkg_group: 'base'
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/public/mall/getregfromagent' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    // 获取商品列表
    getShowList() {
        let obj = {
            pkg_group: 'base'
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/shop/stall/package/' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    // 通过code获取商品详情 
    getShowItem(code) {
        let obj = {
            code
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/shop/stall/packageorder/' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    // 获取微信支付二维码
    getVXqrCode(body) {
        let nodes = Vue.prototype.$baseConfig.code
        return new Promise((resolve, reject) => {
            WebPost('/api/shop/buy/package' + '', body, nodes)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    // 是否已微信支付完成
    getVXisPay(body) {
        let nodes = Vue.prototype.$baseConfig.code
        return new Promise((resolve, reject) => {
            WebPost('/api/shop/buy/paycompleted' + '', body, nodes)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    /////////////////////////商城&&支付接口////////////////////////////////////////////////////////////////////

    //获取产品展示列表V2
    reqGetProductsV2() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/v2/productlist', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //计算产品升级信息
    reqCountUpgradeData(args) {
        var bodyJson = {
            upproductcode: args.upproductcode,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/v2/product_upgrade_calc', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //产品升级
    reqProductUpgrade(args) {
        var bodyJson = {
            upproductcode: args.upproductcode,
            paytype: args.paytype,
            invoice: args.invoice,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/v2/product_upgrade', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }



    //获取产品展示列表
    reqGetProducts() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/productlist', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取产品优惠列表
    reqProductDiscountList(pcode) {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/productdiscount/' + pcode + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //购买会员等级下单
    reqCreateOrder(args) {
        var bodyJson = {
            product: args.product,
            discount: args.discount,
            paytype: args.paytype,
            couponcode: args.couponcode,
            agentcode: args.agentcode,
            invoice: args.invoice,
            wxopenid: args.wxopenid,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/postproductorder', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //续费会员等级下单
    reqRenewOrder(args) {
        var bodyJson = {
            product: args.product,
            discount: args.discount,
            paytype: args.paytype,
            couponcode: args.couponcode,
            agentcode: args.agentcode,
            invoice: args.invoice,
            wxopenid: args.wxopenid,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/postproductcontinueorder', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //获取扩展功能包
    reqProductPackages(pcode, orderid) {
        var params = {}
        console.log('reqProductPackages.pcode:' + pcode + 'orderid:' + orderid)
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/extfunctionlist/' + pcode + '/' + orderid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取扩展功能优惠
    reqPackageDiscount(args) {
        var bodyJson = {
            productcode: args.productcode,
            productorderid: args.productorderid,
            paytype: args.paytype,
            extfunc: args.extfunc
        }
        console.log('获取扩展功能优惠====>')
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/checkfunctionorderandcalediscount', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //功能扩展包下单
    reqCreatePackageOrder(args) {
        var bodyJson = {
            productcode: args.productcode,
            productorderid: args.productorderid,
            paytype: args.paytype,
            extfunc: args.extfunc,
            couponcode: args.couponcode,
            agentcode: args.agentcode,
            invoice: args.invoice,
            wxopenid: args.wxopenid,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/postfunctionorder', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //查询订单支付状态
    reqGetOrderState(orderid) {
        var params = {}
        console.log('query orderid========>' + orderid)
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/checkorderpaystatus/' + orderid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取已订购的产品列表
    reqGetUserProduct() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/getuserproduct', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取已订购的功能列表
    reqGetUserPackage() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/getuserfunction', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取订单列表
    reqGetOrderList() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/getorderlist', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }


    //获取用户权限
    reqGetUserPermission() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/security/user/getpremission', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }


    //获取发票抬头信息
    reqGetInvoiceTitle() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/getinvoiceheader', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }


    //保存发票抬头信息
    reqSaveInvoiceTitle(args) {
        var bodyJson = {
            headertype: args.headertype,
            headername: args.headername,
            headercode: args.headercode,
            officeaddress: args.officeaddress,
            mobilenumber: args.mobilenumber,
            bankname: args.bankname,
            bankaccount: args.bankaccount,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/saveinvoiceheader', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //订单开票(修改為在提交订单时一起提交开票信息)--已刪除
    reqTakeInvoice(args) {
        var bodyJson = {
            orderid: args.orderid,
            invoicetype: args.invoicetype,
            invoiceheader: args.invoiceheader,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/requestorderinvoice', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取订单合同相关信息
    reqGetOrderContract(orderid) {
        var params = {}
        console.log('Query Contract========>' + orderid)
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/contractinfo/' + orderid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //验证运营商编码
    reqCheckAgency(agentcode) {
        var params = {}
        console.log('Query agentcode========>' + agentcode)
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/validagentcode/' + agentcode + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //验证优惠码
    reqCheckCoupon(couponcode) {
        var params = {}
        console.log('Query couponcode========>' + couponcode)
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/validcouponcode/' + couponcode + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //计算优惠码和运营商编码优惠信息
    reqChcekCouponAndAgentcode(args) {
        var bodyJson = {
            amount: args.amount,
            couponcode: args.couponcode,
            agentcode: args.agentcode,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/calecouponcodeandagentcode', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //获取订单发票列表
    reqGetOrderInvoicelist() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/getorderinvoicelist', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //获取订单合同列表
    reqGetOrderContractList() {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/mall/getordercontractlist', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //发送电子发票到邮箱
    reqSendInvoice(args) {
        var bodyJson = {
            orderid: args.orderid,
            postmobile: args.postmobile,
            postemail: args.postemail,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/invoicesend', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //发票申请换开（停用）
    reqReSendInvoice(args) {
        var bodyJson = {
            orderid: args.orderid,
            invoice: args.invoice,
            headertype: args.headertype,
            headername: args.headername,
            headercode: args.headercode,
            officeaddress: args.officeaddress,
            mobilenumber: args.mobilenumber,
            bankname: args.bankname,
            bankaccount: args.bankaccount,
            postaddress: args.postaddress,
            postemail: args.postemail,
            postmobile: args.postmobile,

        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/mall/reqinvoicechange', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //开具发票
    reqTakeNewInvoice(args) {
        var bodyJson = {
            orderid: args.orderid,
            invoicetype: args.invoicetype,
            invoiceheader: args.invoiceheader,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/mall/reqinvoice', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //换开发票
    reqTakeInvoiceAgain(args) {
        var bodyJson = {
            orderid: args.orderid,
            invoice: args.invoicetype,
            invoiceheader: args.invoiceheader,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/mall/reqinvoicechange', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //关闭文档
    reqCloseDocumentAction(args) {
        var bodyJson = {
            strdocids: args.strdocids,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/closedoc', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //检测用户权限,并返回警告提示以及处理方式
    reqCheckUserPromission(args) {
        var bodyJson = {
            funccode: args.funccode,
            funcname: args.funcname,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/checkpremission', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取tts音频
    reqGetTTSStream(strdocid) {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/search/tts/' + strdocid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }

    //打印文件
    reqPrinter(strdocid) {
        var params = {}
        return new Promise((resolve, reject) => {
            WebGet('api/public/search/print/' + strdocid + '', params)
                .then(function(resp) {
                    resolve(resp)
                }).catch(function(err) {
                    reject(err)
                })
        })
    }
    //发送邮件
    reqSendMailWithFile(args) {
        var bodyJson = {
            strdocid: args.strdocid,
            email: args.email,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/email', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //////////////////////////////////////////微信接口///////////////////////////////////////

    //请求获取二维码或拉起微信授权的URL
    reqWXUrl(args) {
        var bodyJson = {
            http_redirct: args.http_redirct
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/requrl', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //微信授权登录
    reqWXLogin(args) {
        var bodyJson = {
            code: args.code,
            state: args.state,
            tempuserid: args.tempuserid
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/login', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //微信注册并登录v2
    reqWXRegLoginV2(args) {
        var bodyJson = {
            code: args.code,
            state: args.state,
            userid: args.userid,
            mobile: args.mobilenum,
            tempuserguid: args.tempuserguid,
            password: args.password,
            smscode: args.smscode,
            companyname: args.unitname,
            companytel: args.unittel,
            province: args.province,
            city: args.city,
            industry: args.industrycode,
            username: '',
            isscanned: false,
            fromagent: '',
            fromdesc: ''
        }
        console.log('reqWXRegLoginV2====>')
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/v3/reglogin', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //微信注册
    reqWXReg(args) {
        var bodyJson = {
            code: args.code,
            state: args.state
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/reg', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //微信注册和登录
    reqWXRegAndLogin(args) {
        var bodyJson = {
            code: args.code,
            state: args.state,
            tempuserid: args.tempuserid
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/reglogin', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //适用于团购账号购买产品后修改账号，微信注册用户购买产品后修改账号
    reqEditUserId(args) {
        var bodyJson = {
            smscode: args.smscode,
            userid: args.userid,
            password: args.password,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/security/user/updateuserid', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //微信登录后修改账号(原来逻辑修改账号前需要先验证手机)
    reqWXEditUserId(args) {
        var bodyJson = {
            mobilenum: args.mobilenum,
            // smscode:args.smscode,
            // reqidentity:args.reqidentity,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/wxupdateuserid', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //微信登录后修改账号
    reqWXCreateUserId(args) {
        var bodyJson = {
            userid: args.userid,
            password: args.password,
            mobilenum: args.mobilenum,
            smscode: args.smscode,
            reqidentity: args.reqidentity,
            realname: args.realname,
            remark: args.remark,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/createuserid', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //微信登录后绑定账号
    reqWXBindUserId(args) {
        var bodyJson = {
            mobilenum: args.mobilenum,
            smscode: args.smscode,
            reqidentity: args.reqidentity,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/binduser', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //微信登录后绑定微信
    reqBindWX(args) {
        var bodyJson = {
            code: args.code,
            state: args.state,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/userbind', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }




    //////////////////////////////////////////微信end//////////////////////////////////////


    //////////////////////////////////////////微信客制化登录///////////////////////////////
    //请求获取登录二维码
    //request parameter key model,value 1、注册，2、登录，3、关联
    reqWXQRcode(args) {
        var bodyJson = {
            model: args.model
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/getqrcode', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }


    //custom wexin login, polling Code and State
    reqPollingCodeAndState(args) {
        var bodyJson = {
            identity: args.identity,
            model: args.model,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/getcodeandstate', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //关闭二维码
    reqCloseQRCode(args) {
        var bodyJson = {
            identity: args.identity,
            model: args.model,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/oauth2/wx/closeqrcode', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }



    //////////////////////////////////////////微信客制化登录end/////////////////////////////



    ////////////////yanghao/////////////////////////////////////////////////////////////


    //設置消息通知已读
    reqSetNoticeRead(args) {
        var bodyJson = {
            state: args.state,
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('api/public/security/user/updatenotice', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //查询优惠税收政策提醒文件列表
    getPushListOfTaxBreak(args) {
        let obj = {
            querytype: args.querytype,
            page: args.page,
            line: args.line,
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushfilelog/pushfilelist' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //查询最新文件列表
    getPushListOfLast(args) {
        let obj = {
            page: args.page,
            line: args.line,
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushdoc/newpushdoclist' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //设置最新政策提醒文件已读
    setOneOfLastPushFileIsRead(args) {
        let obj = {
            strdocid: args.strdocid,
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushdoc/setreaded' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //设置全部最新政策提醒文件已读
    setAllOfLastPushFilesIsRead(args) {
        let obj = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushdoc/setallreaded' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //设置税收优惠政策提醒文件已读
    setOneOfTaxFileIsRead(args) {
        let obj = {
            strdocid: args.strdocid,
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushfilelog/setreaded' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    //设置全部税收优惠政策提醒文件已读
    setAllOfTaxFilesIsRead(args) {
        let obj = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushfilelog/setallreaded' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取用户关注的行业
    getUserSetting(){
         let obj = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/secretary/pushfilelog/issetindustry' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取用户推广码
    getPromoCode(){
         let obj = {}
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/getspreadlink', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //绑定分销商（金管家）
    bindDistributor(){
         let obj = {}
        return new Promise((resolve, reject) => {
            WebPost('/api/public/security/user/bindjgjcode', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取用户发展的客户
    getCustomer(args){
        let obj = {
            page: args.page,
            line: args.line,
        }
        return new Promise((resolve, reject) => {
            WebGet('/api/public/security/user/getspreaduser' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //获取中国税务报分类信息
    getTaxCaseCategory(){
         let obj = {}
        return new Promise((resolve, reject) => {
            WebGet('/api/public/base/taxnews' + '', obj)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //智能问答
    reqChatSearch(args) {
        var bodyJson = {
            chattype: args.chattype,
            question: args.question
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/chat', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //问答历史记录
    reqChatHistory(args) {
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/findchathistory', args)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    //查阅某一个历史会话记录
    reqChatHistoryView(args) {
        var bodyJson = {
            requestid:args.requestid
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/getchathistorydetail', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }
    
    //删除某一个历史会话记录
    reqChatHistoryDelete(args) {
        var bodyJson = {
            requestid:args.requestid
        }
        console.log(bodyJson)
        return new Promise((resolve, reject) => {
            WebPost('/api/public/search/delchathistory', bodyJson)
                .then(function(resp) {
                    resolve(resp);
                }).catch(function(err) {
                    reject(err);
                })
        })
    }

    ////////////////end////////////////////////////////////////////////////////


}